<template>
    <a-modal
    :visible="showModal"
    :title="'Help: ' + help_title"
    width="100%"
    wrap-class-name="full-modal"
    @ok="handleClose"
    @cancel="handleClose"
    :footer="null"
    >
    <div style="max-height:80%; overflow: scroll;" v-html="help_data">
    </div>
    
</a-modal>
</template>
<script>
import eventBus from '@/config/eventBus'

export default {
    name: 'HelpModal',
    components: {
    },
    watch: {
        
    },
    computed: {
    },
    data() {
        return {
            help_title: '',
            help_data: '',
            help_url: '',
            showModal: false,
        }
    },
    methods: {
        strip_links(htmlText) {
            return htmlText.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '$1');
        },
        handleClose() {
            this.showModal = false
        },
        retrieve_help(help_url) {
            this.$http
            .get(help_url)
            .then(response => {
                if (response) {
                    this.help_data = response
                    this.help_title = this.help_data.title
                    this.help_data = this.strip_links(response.body)
                    this.showModal = true
                } else {
                    this.help_data = 'Help is not yet available for this topic'
                }
            })
            .catch(() => {
                this.help_data = "It seems guides for this section are not ready yet."
            })
        },
    },
    mounted() {
        eventBus.on('showHelpModal', (data) => {
            this.help_url = data.replace('html', 'fjson')
            this.retrieve_help(this.help_url)
        })
        
    },
    beforeUnmount() {
    }
}
</script>

<style lang="less">
.full-modal {
    z-index:999999;
    .ant-modal {
        max-width: 100%;
        top: 0;
        padding-bottom: 0;
        margin: 0;
    }
    .ant-modal-content {
        display: flex;
        flex-direction: column;
        height: calc(100vh);
    }
    .ant-modal-body {
        flex: 1;
    }

    }  
    img {
        max-width: 400px !important;
        height: auto;
    }
</style>
